import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Nested overflow so Windows does not promote a vertical scrollbar from `overflow-x-auto`.
 * The inner wrapper owns horizontal scroll; the outer owns vertical scroll only when asked.
 */
export function SuntronicInvoiceTableShell({
  children,
  className,
  allowVerticalScroll = false,
}: {
  children: ReactNode;
  className?: string;
  allowVerticalScroll?: boolean;
}): JSX.Element {
  const table = <table className="min-w-full divide-y divide-slate-200 text-sm">{children}</table>;
  const framed = (
    <div className="overflow-x-auto overflow-y-hidden rounded-lg border border-slate-200">{table}</div>
  );
  if (!allowVerticalScroll) {
    return <div className={className}>{framed}</div>;
  }
  return <div className={cn("min-h-0 overflow-y-auto", className)}>{framed}</div>;
}

export function SuntronicInvoiceTableEmpty({ children }: { children: ReactNode }): JSX.Element {
  return <p className="px-5 py-4 text-sm text-slate-600">{children}</p>;
}
